module.exports = __webpack_public_path__ + "img/curve-3-2.1c66d339.svg";